"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";

import { ConsentModal } from "./ConsentModal";

export function CookieSettingsLink({ className }: { className?: string }) {
  const t = useTranslations("footer");
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className ?? "text-left hover:text-[#F6F8FC]"}
        onClick={() => setOpen(true)}
      >
        {t("cookieSettings")}
      </button>
      <ConsentModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
